import { Badge as ChakraBadge, BadgeProps } from '@chakra-ui/react';

export const Badge = ({
  icon,
  children,
  ...props
}: {
  icon?: React.ReactNode;
} & BadgeProps) => (
  <ChakraBadge pr={icon ? 2.5 : 2} {...props}>
    {icon}
    {children}
  </ChakraBadge>
);
